import { render, staticRenderFns } from "./ExamLabel.vue?vue&type=template&id=075ebd94&scoped=true"
import script from "./ExamLabel.vue?vue&type=script&lang=js"
export * from "./ExamLabel.vue?vue&type=script&lang=js"
import style0 from "./ExamLabel.vue?vue&type=style&index=0&id=075ebd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075ebd94",
  null
  
)

export default component.exports